import { bridgelessRestApiClient } from '@/api/clients'
import { buildPaginationParams } from '@/helpers'
import { CoinAmount, PaginationParams, PaginationResponse } from '@/types'

export interface BankBalancesResponse {
  balances: CoinAmount[]
  pagination: PaginationResponse
}

export async function fetchBalances(
  accountAddress: string,
  pagination?: PaginationParams,
): Promise<BankBalancesResponse> {
  const { data } = await bridgelessRestApiClient.get<BankBalancesResponse>(
    `/cosmos/bank/v1beta1/balances/${accountAddress}`,
    {
      params: buildPaginationParams(pagination),
    },
  )

  return data
}
